"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmEmailRegister = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var ConfirmEmailRegisterAction_1 = require("@/pages/confirmEmailRegister/actions/ConfirmEmailRegisterAction");
var ConfirmEmailRegisterFormComponent_1 = require("@/pages/confirmEmailRegister/components/ConfirmEmailRegisterFormComponent");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var mapStateToProps = function (state) {
    return state.confirmEmailRegister;
};
var mapDispatchToProps = function (dispatch) { return ({
    onConfirmEmailRegsiterSubmit: function (confirmEmailRegisterForm) {
        return dispatch(ConfirmEmailRegisterAction_1.default.onConfirmClicked(confirmEmailRegisterForm));
    },
}); };
exports.confirmEmailRegister = function (props) {
    var confirmEmailRegisterForm = props.confirmEmailRegisterForm, tForm = props.tForm, isLoading = props.isLoading, onConfirmEmailRegsiterSubmit = props.onConfirmEmailRegsiterSubmit, dialCodes = props.dialCodes, salutations = props.salutations;
    var formUi = {
        isLoading: isLoading, dialCodes: dialCodes, salutations: salutations,
        defaultForm: confirmEmailRegisterForm,
    };
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { id: "confirm-email-register-page", className: "l-container l-container--rslim" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "c-page-header c-page-header--center l-pad-top" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.nameTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.nameCaption))),
                React.createElement(ConfirmEmailRegisterFormComponent_1.default, { form: confirmEmailRegisterForm, tForm: tForm, ui: formUi, onFormSubmit: onConfirmEmailRegsiterSubmit })))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.confirmEmailRegister);
